var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBattery4Black(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M278.1,1040c-15,0-25-5-35-15c-10-10-15-20-15-35V190c0-15,5-25,15-35c10-10,20-15,35-15h100V90c0-15,5-25,15-35 c10-10,20-15,35-15h100c15,0,25,5,35,15s15,20,15,35v50h100c15,0,25,5,35,15s15,20,15,35v350c-85,0-155,30-210,90 c-60,60-90,130-90,210c0,40,5,75,20,110c15,35,30,65,55,90H278.1z M328.1,440h300V240h-300V440z M623.1,890c-10,0-15-5-20-15 c-5-10-5-15,0-25l125-180c5-5,10-5,15-5c5,0,10,5,10,10v110h75c10,0,15,5,20,15c5,10,5,15,0,25l-125,180c-5,5-10,5-15,5s-10-5-10-10 V890H623.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery4Black);
export default __webpack_public_path__ + "static/media/battery-4-black.5a4eb87805fa6dd681028af577a53b74.svg";
export { ForwardRef as ReactComponent };